export type TariffWithHtsNumber = {
  htsNumber?: string;
  number?: string;
  hts?: {
    number: string;
  };
  [key: string]: any; // Preserve all other tariff data including unitReportingQuantities
};

export const getTariffsWithDefinedHts = (
  existingTariffs: TariffWithHtsNumber[],
): TariffWithHtsNumber[] => {
  return existingTariffs.filter(
    (tariff) =>
      tariff && (tariff.htsNumber || tariff.hts?.number || tariff.number),
  );
};
